import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Table, View, Text, InfiniteScroll } from '@components';
import { getRequisicoes, reset } from '@ducks/conectoresRequisicoes';
import { formatDateTimeS, Notification } from '@utils';

export default function TableRequisicoes() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const requisicoes = useSelector(({ conectoresRequisicoes }) => conectoresRequisicoes.get('requisicoes').toArray());
  const loadingRequisicoes = useSelector(({ conectoresRequisicoes }) => conectoresRequisicoes.get('loadingRequisicoes'));
  const hasMoreRequisicoes = useSelector(({ conectoresRequisicoes }) => conectoresRequisicoes.get('hasMoreRequisicoes'));
  const xCurrentPage = useSelector(({ conectoresRequisicoes }) => conectoresRequisicoes.get('xCurrentPage'));

  const handleSearch = () => {
    if (!loadingRequisicoes) {
      dispatch(getRequisicoes(id, xCurrentPage + 1));
    }
  };

  const handleInfiniteOnLoad = () => {
    if (!hasMoreRequisicoes) {
      Notification.warning('Todos as requisições foram retornadas');
    } else {
      handleSearch();
    }
  };

  const handleReset = () => {
    dispatch(reset());
  };

  useEffect(() => {
    handleReset();
  }, []);

  useEffect(() => {
    if (xCurrentPage === 0) handleSearch();
  }, [xCurrentPage]);

  const columns = [
    {
      title: 'Data',
      dataIndex: 'dt',
      key: 'dt',
      render: (text) => (
        <View>
          <Text>{formatDateTimeS(text)}</Text>
        </View>
      ),
    },
    {
      title: 'Tipo',
      dataIndex: 'tp',
      key: 'tp',
    },
  ];

  return (
    <InfiniteScroll dataLength={requisicoes.length} next={handleInfiniteOnLoad} hasMore={loadingRequisicoes && hasMoreRequisicoes}>
      <Table rowKey='id' columns={columns} dataSource={requisicoes} loading={loadingRequisicoes} hidePagination />
    </InfiniteScroll>
  );
}
